import { useState, useEffect, useRef } from "react";
import DrPatientListTable from "./DrPatientListTable";
import { useNavigate } from "react-router-dom";
import { Panel, PanelGroup, Placeholder } from "rsuite";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Whisper, Tooltip } from "rsuite";
import { RiGridFill, RiListUnordered } from "react-icons/ri";
import { FiUser, FiSearch, FiX } from "react-icons/fi";
import ClinicFilterPopover from "./ClinicFilterPopover";
import DrPatientGrid from "./DoctorComponent.jsx/DrPatientGrid";
import {
  useLazyGetPatientsDoctorsideQuery,
  usePostFilteredOutpatientsMutation,
} from "../State/Api/GetoutpatientApiSlice";
import ClinicPatientFilters from "./ClinicsidePatientFilters";
import PatientViewFilters from "./ClinicComponent/Filters/ClinicFilterJSON/PatientView";
import DefaultPatientFilters from "./ClinicComponent/Filters/DefaultPatientFilters";
import OutpatientViewFilters from "./ClinicComponent/Filters/ClinicFilterJSON/OutpatientView";

function DrPatientsList() {
  const [show, setShow] = useState(false);
  const [emerShow, setEmerShow] = useState(false);
  const [patientDetail, setPatientDetail] = useState("");
  const [reportSearch, setReportSearch] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleProfClose = () => setEditProfShow(false);
  const [EditProfShow, setEditProfShow] = useState(false);

  const [activeView, setActiveView] = useState("list");

  // const [fetchPatientsDoctorside, { data = [], isFetching, isSuccess, isLoading }] =
  //   useLazyGetPatientsDoctorsideQuery();

  // useEffect(() => {
  //   const clinicUserId = localStorage.getItem("userClinicID");
  //   const DoctorUserUniqueID = localStorage.getItem("userUniqueID");
  //   if ({clinicUserId,DoctorUserUniqueID}) {
  //     fetchPatientsDoctorside({clinicUserId,DoctorUserUniqueID});
  //   }
  // }, []);

  const gridRef = useRef(null);
  const [hasData, setHasData] = useState(true);

  const clinicUserId = localStorage.getItem("userClinicID");

  const DoctorUserUniqueID = localStorage.getItem("userUniqueID");

  const prevFiltersRef = useRef([]);

  useEffect(() => {
    // Only purge if filters actually changed
    if (
      JSON.stringify(prevFiltersRef.current) !== JSON.stringify(selectedFilters)
    ) {
      gridRef?.current?.api?.purgeInfiniteCache();
      prevFiltersRef.current = selectedFilters;
    }
  }, [selectedFilters]);

  const [fetchFilteredOutPatients, { isLoading, isFetching, isSuccess }] =
    usePostFilteredOutpatientsMutation();

  const getOutPatients = async (pageNumber, filters, sortColumn = "", sortOrder = "") => {
    try {
      const result = await fetchFilteredOutPatients({
        pageNumber: pageNumber,
        pageSize: 100,
        userClinicID: clinicUserId,
        doctorUserUniqueID: DoctorUserUniqueID,
        filters: filters,        
        sortColumn: sortColumn,
        sortOrder: sortOrder
      }).unwrap();

      return result;
    } catch (err) {
     
    }
  };

  useEffect(() => {
    gridRef?.current?.api?.purgeInfiniteCache();
  }, [selectedFilters]);

  const handleSearch = () => {
    let searchValue = reportSearch.trim();

    if (!searchValue) {
      // Clear filters if search empty
      setSelectedFilters((prev) => {
        const { patientName, patientID, ...rest } = prev;
        return rest;
      });
      return;
    }

    let newFilter;

    if (/^PLCRXPAT\d+$/i.test(searchValue)) {
      // Already formatted Patient ID
      newFilter = {
        patientID: {
          values: new Set([searchValue]),
          operator: "Contains",
        },
      };
    } else if (/^\d+$/.test(searchValue)) {
      // Only numbers → prepend prefix
      const prefixedValue = `PLCRXPAT${searchValue}`;
      newFilter = {
        patientID: {
          values: new Set([prefixedValue]),
          operator: "Contains",
        },
      };
    } else {
      // Otherwise treat as name
      newFilter = {
        patientName: {
          values: new Set([searchValue]),
          operator: "Contains",
        },
      };
    }

    setSelectedFilters((prev) => {
      const { patientName, patientID, ...rest } = prev;
      return { ...rest, ...newFilter };
    });
  };

  const handleClearSearch = () => {
    setReportSearch("");
    setSelectedFilters((prev) => {
      const { patientName, patientID, ...rest } = prev;
      return rest;
    });
    setHasData(true);
  };

  const getButtonClasses = (view) => {
    const isActive = activeView === view;
    return [
      "flex-1 flex items-center justify-center h-[36px] w-[50px] transition-all",
      isActive
        ? "bg-[#203342] text-white"
        : "bg-white text-[#203342] hover:bg-gray-100",
    ].join(" ");
  };
  const navigate = useNavigate();
  return (
    <>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4 d-flex flex-wrap justify-content-between align-items-center"
          >
            <div className="d-flex justify-content-between">
              <div>
                <h2 className="h3 fw-bold mb-0" style={{fontSize:'24px'}}>Patients</h2>
                {/* <p className="text-secondary">
                  Manage patient records efficiently.
                </p> */}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3">
              <label className="relative">
                <input
                  type="text"
                  className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm   focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
                  placeholder="Enter patient name or ID"
                  value={reportSearch}
                  onChange={(e) => {
                    const value = e.target.value;
                    setReportSearch(value);

                    if (value.trim() === "") {
                      setSelectedFilters((prev) => {
                        const { fullName, patientIDUniqueID, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                />
                {reportSearch && (
                  <span
                    className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer"
                    onClick={handleClearSearch}
                  >
                    <FiX size={16} />
                  </span>
                )}
                <span
                  className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-gray-200 p-2 rounded-md text-white cursor-pointer"
                  onClick={handleSearch}
                >
                  <FiSearch size={16} />
                </span>
              </label>
              <Whisper
                placement="top"
                trigger="hover"
                speaker={<Tooltip>Filter Options</Tooltip>}
              >
                <DefaultPatientFilters
                  defaultFilters={OutpatientViewFilters.defaultdoctor}
                  additionalFilters={OutpatientViewFilters.additional}
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  setHasData={setHasData}
                />
              </Whisper>
              <div className="flex rounded-md overflow-hidden shadow-sm border border-gray-200 ml-[5px] w-fit">
                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={<Tooltip>List view</Tooltip>}
                >
                  <button
                    onClick={() => setActiveView("list")}
                    className={getButtonClasses("list")}
                  >
                    <RiListUnordered size={20} />
                  </button>
                </Whisper>
                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={<Tooltip>Grid view</Tooltip>}
                >
                  <button
                    onClick={() => setActiveView("grid")}
                    className={getButtonClasses("grid")}
                  >
                    <RiGridFill size={20} />
                  </button>
                </Whisper>

                {/* <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={<Tooltip>Filter Options</Tooltip>}
                >
                  <button
                    onClick={() => {
                      setActiveView("filter");
                    }}
                    type="button"
                    className={getButtonClasses("filter")}
                  >
                    <ClinicFilterPopover />
                  </button>
                </Whisper> */}
              </div>
            </div>
          </div>
          {/* <div className="col-12 d-flex align-items-center mb-4 justify-content-end">
            <span>Choose Date<DatePicker style={{marginLeft:"1rem"}} />  </span>
        </div> */}
        </div>
        {(activeView === "list" || activeView === "filter") && (
          <DrPatientListTable
            getOutPatients={getOutPatients}
            isFetching={isFetching}
            isLoading={isLoading}
            isSuccess={isSuccess}
            gridRef={gridRef}
            selectedFilters={selectedFilters}
            hasData={hasData}
            setHasData={setHasData}
          />
        )}
        {activeView === "grid" && (
          <DrPatientGrid
            getOutPatients={getOutPatients}
            isFetching={isFetching}
            isLoading={isLoading}
            isSuccess={isSuccess}
            selectedFilters={selectedFilters}
          />
        )}

        <Offcanvas
          show={show}
          onHide={handleClose}
          placement={"end"}
          style={{
            width: "22rem",
            margin: ".5rem .5rem",
            borderRadius: "0.5rem 0rem 0px .5rem",
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              className="text-black"
              style={{ fontSize: "18px" }}
            >
              Filters
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ padding: "none" }}>
            <div className="">
              <PanelGroup accordion className="no-border">
                <Panel header="Check-In Date ">
                  <div className="d-flex align-items-center gap-2">
                    <input type="date" className="form-control" />
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Status">
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Pending</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>On Recovery </span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Recovered</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Diagnosis Filter">
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Allergies & Asthma</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Dental Care </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>Diabetes</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>Hearing Loss</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>Sleep Problem</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>Other Diagnoses</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Check-In Type">
                  <div className="position-relative div-okij8ijj mb-3">
                    <input
                      type="text"
                      className="form-control div-sdwfegere"
                      placeholder="Search"
                      style={{ padding: ".3rem .2rem", borderRadius: ".3rem" }}
                    />
                    <div
                      className="position-absolute"
                      style={{ top: "5px", right: ".2rem" }}
                    >
                      <button style={{ background: "none", border: "none" }}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>In-person</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Virtual</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Emergency</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Walk-in</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Home Visit</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Telehealth</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Consultation</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Second Opinion</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Follow-up Visit</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Patient Name">
                  <div className="position-relative div-okij8ijj mb-3">
                    <input
                      type="text"
                      className="form-control div-sdwfegere"
                      placeholder="Search"
                      style={{ padding: ".3rem .2rem", borderRadius: ".3rem" }}
                    />
                    <div
                      className="position-absolute"
                      style={{ top: "5px", right: ".2rem" }}
                    >
                      <button style={{ background: "none", border: "none" }}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>
                </Panel>
              </PanelGroup>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </main>
    </>
  );
}

export default DrPatientsList;
